import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=70c4511f&"
import script from "./MaterialChartCard.vue?vue&type=script&lang=ts&"
export * from "./MaterialChartCard.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&id=70c4511f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports